/* eslint-disable */
export default {
  _GoodJobPopup: 'GoodJobPopup',
  _InstructionsPopup: 'InstructionsPopup',
  _TryAgainText: 'TryAgainText',
}